import React, {Component} from 'react'
import update from 'immutability-helper'
import Instrument from './Instrument'
import instrumentData from './instrumentData'
import './Instrument.css'

class InstrumentContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      instruments: instrumentData
    }
  }

  componentDidMount() {
    this.props.player.on('start', () => this.startSync())
    this.props.player.on('loopStart', () => this.startSync())
  }

  componentDidUpdate() {
    if (this.props.playerShouldStop) {
      this.props.confirmPlayerStop()
    }
  }

  startSync() {
    this.state.instruments.forEach((inst, index) => {
      if (inst.trackToPlay >= 0 && inst.playing) {
        if (inst.tracks[inst.trackToPlay].track.loaded) inst.tracks[inst.trackToPlay].track.sync().start()
        if (inst.tracks[inst.currentTrack] && inst.tracks[inst.currentTrack] !== inst.tracks[inst.trackToPlay]) {
          inst.tracks[inst.currentTrack].track.unsync().stop()
        }
        const newData = update(this.state.instruments, {
          [index]: {
            currentTrack: {$set: inst.trackToPlay},
            trackToPlay: {$set: -1}
          }
        })
        this.setState({
          instruments: newData
        })
      }
    })
  }

  handleTrackSelect(inst, track) {
    if (this.props.player.state === 'stopped') this.props.handlePlayerToggle()
    if (this.props.goodBeatPlaying) this.props.goodBeatToStop()
    const instrument = this.state.instruments.find(i => i.name === inst)
    const instNum = this.state.instruments.indexOf(instrument)
    const trackToPlay = this.state.instruments[instNum].tracks.indexOf(
      instrument.tracks.find(t => t.name === track)
    )
    const newData = update(this.state.instruments, {
      [instNum]: {
        playing: {$set: true},
        trackToPlay: {$set: trackToPlay}
      }
    })

    this.setState({
      instruments: newData
    })
  }

  handleOnOff(instNum) {
    const trackNum = this.state.instruments[instNum].tracks.indexOf(
      this.state.instruments[instNum].tracks.find(
        t => t.id === this.state.instruments[instNum].currentTrack
      )
    )
    let newData = {}
    if (this.state.instruments[instNum].playing) {
      this.state.instruments[instNum].tracks[trackNum].track.unsync().stop()
      newData = update(this.state.instruments, {
        [instNum]: {
          playing: {$set: false}
        }
      })
    } else {
      if (this.props.player.state === 'stopped') this.props.handlePlayerToggle()
      if (this.props.goodBeatPlaying) this.props.goodBeatToStop()
      newData = update(this.state.instruments, {
        [instNum]: {
          playing: {$set: true},
          trackToPlay: {$set: trackNum}
        }
      })
    }
    this.setState({
      instruments: newData
    })
  }

  handleVolume(inst, e) {
    const instUpdate = this.state.instruments.find(i => i.name === inst)
    const instNum = this.state.instruments.indexOf(instUpdate)
    const newVol = Math.round((Math.pow(6.3 * e.target.value, 0.6) - 48))
    this.state.instruments[instNum].tracks.forEach((track, index) => {
      const newData = update(this.state.instruments, {
        [instNum]: {
          tracks: {
            [index]: {
              track: {volume: {value: {$set: newVol}}}
            }
          }
        }
      })
      this.setState({
        instruments: newData
      })
    })
  }
  
  render() {
    const instruments = this.state.instruments.map(instrument => (
      <Instrument 
        key={instrument.id}
        id={instrument.id}
        name={instrument.name}
        playing={instrument.playing}
        toPlay={instrument.trackToPlay}
        currentTrack={instrument.currentTrack}
        tracks={instrument.tracks}
        playerPlaying={this.props.player.state}
        handleOnOff={(e) => this.handleOnOff(e)}
        handleTrackSelect={(inst, track) => this.handleTrackSelect(inst, track)}
        handleVolume={(inst, e) => this.handleVolume(inst, e)}
      />
    ))
    return (
      <div className={`instrumentContainer ${this.props.goodBeatPlaying ? 'goodBeatsOn' : ''}`}>
        {instruments}
      </div>
    )
  }
}

export default InstrumentContainer


// WEBPACK FOOTER //
// ./src/Instrument/InstrumentContainer.js